/* eslint-disable */
/**
 * This file was generated by Itecho.TSGen tool
 * Version and info generated in .version
 * Any changes to this file will be lost if regenerated 
 */

import { webRequest, fileRequest } from "../request";
import type CropBrakePointDisplay from "../interfaces/cropBrakePointDisplay";
import type CropBrakePointRequest from "../interfaces/cropBrakePointRequest";
import type CultivarDisplay from "../interfaces/cultivarDisplay";
import type IdRequest from "../interfaces/idRequest";
import type PaginationRequestId from "../interfaces/paginationRequestId";
import type PaginationRequestSearch from "../interfaces/paginationRequestSearch";
import type PaginationResponse from "../interfaces/paginationResponse";

export default {
    paged: (request: PaginationRequestSearch) => webRequest<PaginationResponse<CropBrakePointDisplay>>('/api/crop/paged', {
        method: 'post',
        body: request
    }),
    cultivarsPaged: (request: PaginationRequestId) => webRequest<PaginationResponse<CultivarDisplay>>('/api/crop/cultivarspaged', {
        method: 'post',
        body: request
    }),
    upsertBrakePoint: (request: CropBrakePointRequest) => webRequest<unknown>('/api/crop/upsertbrakepoint', {
        method: 'post',
        body: request
    }),
    deleteBrakePoint: (request: IdRequest) => webRequest<unknown>('/api/crop/deletebrakepoint', {
        method: 'post',
        body: request
    })
}